import { GET_COUNTRIES_SUCCESS } from "../../actionTypes";

export default function countries(state = [], action) {
    if (!action) return state;

    switch (action.type) {
        case GET_COUNTRIES_SUCCESS:
            return action.countries;
        default:
            return state;
    }
}
